
export enum GabcDetermination {
  NO_END,
  END_OF_CURRENT,
  END_OF_PREVIOUS,
  END_OF_BOTH
}
